/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScanDocumentListModel { 
    scanDocumentId?: number;
    scanDocumentTypeId?: number;
    scanDocumentNumber?: string | null;
    scanDocumentFormat?: number;
    timeStamp?: string;
    userId?: number;
    statusId?: number;
    hasAttachment?: number;
    documentNumber?: string | null;
    documentDate?: string | null;
    customerNumber?: string | null;
    customerName?: string | null;
    documentTotal?: number;
    documentStatus?: number;
    enterByGPUser?: string | null;
    userFirstName?: string | null;
    userLastName?: string | null;
    statusDisplay?: string | null;
    locationId?: number;
    locationIdentifier?: string | null;
    scanDocumentTypeName?: string | null;
    readonly customerNumberDisplay?: string | null;
    readonly documentDateDisplay?: string | null;
    readonly documentTotalDisplay?: string | null;
    readonly scanDocumentFormatDisplay?: string | null;
    readonly documentStatusDisplay?: string | null;
    readonly attachmentDisplay?: string | null;
    documentState?: string | null;
    batchNumber?: string | null;
    referenceNumber?: string | null;
}

